import LastCommentCell from './last_comment_cell';

export default LastCommentCell;
